module.exports = __webpack_public_path__ + "media/images/photo/high_speed_internet-cbda3eea9d677a76b7963520ada87e4c.png";